<script setup lang="ts">
import GwMenuNew from '@/components/lib/GwMenuNew/GwMenuNew.vue'
import GwSurface from '@/components/lib/base/GwSurface/GwSurface.vue'
import GwInput from '@/components/lib/GwInput.vue'
import { t } from '@/locales/i18n'
import { ref, nextTick } from 'vue'
import ColorTagSelect from '@/components/lib/GwTable/ColorNote/ColorTagSelect.vue'
import NoteIcon from '@/components/lib/GwTable/ColorNote/NoteIcon.vue'

interface ColorNoteMenuProps {
  note: string
  colorHex?: string
}

const props = withDefaults(defineProps<ColorNoteMenuProps>(), {
  colorHex: '',
})
const l_note = ref(props.note)
const inputRef = ref<HTMLElement | null>(null)

const emit = defineEmits<{
  update: [value: string]
  'update:color': [value: string]
}>()

const handleInput = (_: InputEvent, value: string) => {
  l_note.value = value
}

const handleOpen = () => {
  l_note.value = props.note
  nextTick(() => {
    inputRef.value?.focus()
  })
}
</script>

<template>
  <GwMenuNew
    placement="right-start"
    boxVariant="box_dialog"
    close-on-click
    @close="emit('update', l_note)"
    @open="handleOpen"
  >
    <template #opener="{ listeners, isOpen }">
      <div
        class="d-flex cursor-pointer"
        v-on="listeners"
      >
        <NoteIcon
          :value="note"
          :isMenuOpen="isOpen"
        />
        <i
          class="mdi mdi-circle mdi-18px mr-2"
          :style="{
            color: colorHex || 'var(--app-surface-4)',
          }"
        />
      </div>
    </template>
    <template #content="{ methods }">
      <GwSurface
        variant="surface_2"
        class="w-100 f-column"
        style="padding: var(--app-pad-1); border-radius: var(--app-rad-4)"
      >
        <GwSurface
          variant="surface_2"
          class="w-100 f-column"
          style="padding: var(--app-pad-3); border-radius: var(--app-rad-4); background: #12121266"
        >
          <ColorTagSelect
            :colorHex
            class="px-1 pb-1"
            style="--icon-gap: 0.15rem; --mobile-icon-size: 2.5rem"
            @update:color="
              val => {
                emit('update:color', val)
                methods.close()
              }
            "
          />
          <GwSurface
            variant="surface_1"
            class="w-100 f-center"
            style="border-radius: var(--app-rad-4)"
          >
            <GwInput
              ref="inputRef"
              isTextArea
              noResize
              :value="l_note"
              :placeholder="t('hhv3.colorNote.enter_note_text')"
              style="
                --clr-border: var(--app-surface-2);
                --clr-border-focus: var(--app-surface-2);
                border-radius: var(--app-rad-4);
              "
              :style="{ minWidth: '100%' }"
              @input="handleInput"
              @keydown:enter="methods.close()"
            >
              <template #label>
                <div />
              </template>
            </GwInput>
          </GwSurface>
        </GwSurface>
      </GwSurface>
    </template>
  </GwMenuNew>
</template>
